import React, { useState } from "react";
import { Grid, TextField, Button ,Box} from "@mui/material";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";

function HomePageFooter() {
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [emailError, setEmailError] = useState("");
  const [checked, setChecked] = useState(false);
  const [isSubmitSubscribe, setIsSubmitSubscribe] = useState(false);

  const validateForm = (e) => {
    let tempFields = { ...fields };
    tempFields[e.target.name] = e.target.value;
    let tempErrors = { ...errors };
    let formIsValid = true;
    let pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    
    if (tempFields.email !== undefined) {
      if (!tempFields.email.match(pattern)) {
        formIsValid = false;
        setEmailError("Enter Correct Email");
        setChecked(false);
        setErrors(tempErrors);
      } else if (tempFields.email.match(pattern)) {
        setChecked(true);
        tempErrors[e.target.name] = "";
        setEmailError("");
        tempFields[e.target.name] = e.target.value;
      }
    }
    setFields(tempFields);
  };

  const sendMail = async () => {
  try {
    const payload = {
      userEmail: fields.email,
    };

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/auth/sendSubscribeMail`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
          token: Cookies.get("token"),
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();

    if (res.status === 200 && data.success) {
      setIsSubmitSubscribe(true);

      setTimeout(() => {
        setIsSubmitSubscribe(false);
        setFields({ email: "" });
        setChecked(false);
      }, 5000);
    } else {
      console.error("Subscribe Failed:", data.message || "Unknown error");
      setTimeout(() => {
        setIsSubmitSubscribe(false);
      }, 5000);
    }
  } catch (err) {
    console.error("Subscribe Request Failed:", err);
  }
};


  const handleSubscribe = (e) => {
    e.preventDefault();
    if (checked){
       sendMail();
    }
  };
   const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="footerContainer">
      <div className="footerTop">
        <div className="footerCol">
          <img
            src="/json-media/icons/GI-logo.svg"
            alt="Generative Insight"
            width={180}
          />
          <p className="tagline">Stay at the top-of-mind of the consumers</p>
          <p className="address">
            One Pierce Place Suite 455E,
            <br />
            Itasca, IL 60143 USA
          </p>
        </div>

        {/* Pages */}
        <div className="footerCol">
          <h4>Pages</h4>
          <ul className="footerLinks">
            <li>
              <Link to="/" onClick={scrollToTop}>Home</Link>
            </li>
            <li>
              <Link to="/solution" onClick={scrollToTop}>Solutions</Link>
            </li>
            <li>
              <Link to="/pricing" onClick={scrollToTop}>Pricing</Link>
            </li>
            {/* <li>
              <Link to="/resources">Resources</Link>
            </li> */}
            <li>
              <Link to="/about" onClick={scrollToTop}>About Us</Link>
            </li>
          </ul>
        </div>
        <div className="footerCol">
          <h4>Contact</h4>
          <p className="contactItem">
            <img
              src="/json-media/icons/phone.svg"
              alt="phone"
              className="icon"
            />
            +1 708 415 4811
          </p>
          <p className="contactItem">
            <img
              src="/json-media/icons/email.svg"
              alt="email"
              className="icon"
            />
            support@generativeinsight.ai
          </p>
        </div>
        <div className="footerCol">
          <h4>Subscribe Now</h4>
          {isSubmitSubscribe ? (
            <Box className="emailsuccessfulsubmitfooter">
              Thank you! You are a subscriber to the World of Generative Insight!
            </Box>
          ) : (
            <form onSubmit={handleSubscribe} className="subscribeForm">
              <TextField
                required
                autoComplete="off"
                size="small"
                placeholder="Enter your email"
                type="text"
                name="email"
                value={fields.email || ""}
                onChange={(e) => validateForm(e)}
                className="subscribeInput"
              />
              <div className="error-text">{emailError}</div>
              <Button 
                type="submit" 
                variant="contained" 
                className="subscribeBtn"
                disabled={!checked}
              >
                Subscribe
              </Button>
            </form>
          )}
        </div>
      </div>
      <div className="footerBottom">
        <div className="container-home bottomContent">
          <span>© Copyright 2025. Generative Insight All Right Reserved</span>
          <span>
            <Link to="/legal">Legal</Link> |{" "}
            <Link to="/privacy-policy">
              Privacy and Service terms documents
            </Link>
          </span>
        </div>
      </div>
    </footer>
  );
}

export default HomePageFooter;
